/**
 * Configuration UI pour le moteur QCM
 * Ces objets doivent être exposés globalement pour le moteur legacy
 */

export const constQcmUi = {
  hide: "hide",
  disabled: "disabled",
  selected: "selected",
  failed: "failed",
  showtime: "showtime",

  monitBackErrorGen: "Une erreur est survenue, réessayer",
  monitBackTooShortMess: "Votre message est un peu court :) ",

  BRPSIndiceMax1: "Une réponse",
  BRPSIndiceMin2: "Plusieurs réponses",

  // tabEmoteRef: [
  //   [0, "0-faute-qcm.png"],
  //   [1, "1-fautes-qcm.png"],
  //   [2, "2-fautes-qcm.png"],
  //   [3, "3-fautes-qcm.png"],
  //   [4, "4-fautes-qcm.png"],
  //   [5, "5-fautes-qcm.png"],
  //   [6, "6-9-fautes-qcm.png"],
  //   [10, "10-15-fautes-qcm.png"],
  //   [16, "16-et-plus-fautes-qcm.png"]
  // ],

  tabEmoteRef: [
    [0, "0-faute-m.webp"],
    [1, "1-faute-m.webp"],
    [2, "2-fautes-m.webp"],
    [3, "3-fautes-m.webp"],
    [4, "4-fautes-m.webp"],
    [5, "5-fautes-m.webp"],
    [6, "6-9-fautes-m.webp"],
    [10, "10-15-fautes-m.webp"],
    [16, "16-et-plus-m.webp"]
  ],

  mobileTxtMarginLeft: 10,
  mobileTxtMarginRight: 22
};

export const obQcmUI = {
  specificGlobalPropFromJs: {
    sel: ":root",
    questCtHeigth: "--ctQuestHeight",
    diapMarginRight: "--diapRight"
  },

  monitForm: {
    sel: "#qcmMonitForm",
    input: "#qmQuest",
    errorTxt: "#monitSendInfo",
    bt: "#qmSend",
    btQuit: ".btMonitClose",
    sendingState: "msg-encours",
    sentState: "msg-success",
    errorState: "msg-error"
  },

  btValid: { sel: ".btValid" },
  btNext: { sel: ".btNext" },
  btLoading: { sel: ".btLoading" },
  btA: { sel: ".btA" },
  btB: { sel: ".btB" },
  btC: { sel: ".btC" },
  btD: { sel: ".btD" },
  btSwitchSound: { sel: ".btSwitchSound" },
  btSwitchQR: { sel: ".btSwitchQR" },
  btMonit: { sel: ".btMonit" },
  btPreviousCorr: { sel: ".btPreviousCorr" },
  btNextCorr: { sel: ".btNextCorr" },
  btBackToResult: { sel: ".btBackToResult" },
  btSwitchFS: { sel: ".btSwitchFS" },
  btQuit: { sel: ".btQuit" },

  elGoodAnswer: { sel: ".elGoodAnswer" },
  elBadAnswer: { sel: ".elBadAnswer" },
  elCountdownTimer: { sel: ".elCountdownTimer" },

  tfQuestNum: {
    sel: ".elQuestNum",
    text: "span"
  },
  tfQuestNumTot: {
    sel: ".elQuestNumTot",
    text: "span"
  },
  tfQcmTypeAndId: {
    sel: ".elQcmTypeAndId",
    text: "span"
  },
  tfQuestBRPSIndice: {
    sel: ".elQuestBRPSIndice",
    text: "span"
  },

  ctResult: { sel: ".resultCt" },

  resultNumFaults: {
    sel: ".ctResultNumFaults",
    text: "span",
    spe: " faute"
  },

  resultEmote: {
    sel: ".img-score"
  },

  resultNumQuestions: {
    sel: ".ctResultNumFaults",
    text: "span:last-of-type"
  },

  resultTableChildHtml: '<div class="resultTableChild"><span></span></div>',
  resultTableChild: {
    sel: ".resultTableChild",
    text: "span"
  },
  ctResultTable: {
    sel: ".ctResultTable",
    child: '<div class="resultTableChild"><span></span></div>'
  },

  resultThemeChildHtml: '<div class="theme"><div class="theme-img"></div><div class="theme-content"><div class="theme-header"><div class="title"></div><div class="nbfautes"></div></div><div class="theme-body"><div class="pie" style="width: meter%;"></div></div></div></div>',
  resultThemeChild: {
    sel: ".theme",
    title: ".title",
    faults: ".nbfautes",
    pctMeterValue: "meter"
  },
  ctResultThemeList: {
    sel: ".ctResultThemeList",
    child: '<div class="theme"><div class="theme-img"></div><div class="theme-content"><div class="theme-header"><div class="title"></div><div class="nbfautes"></div></div><div class="theme-body"><div class="pie" style="width: meter%;"></div></div></div></div>'
  },

  btGoCorrAll: { sel: ".btGoCorrAll" },
  btGoCorrError: { sel: ".btGoCorrError" },

  ctCoach: {
    sel: ".ctCoach",
    text: "span"
  }
};
